import "./index.scss";
import { IconButton, Button } from "../../shared";
import { Box, Input, ButtonGroup, Dropdown, Menu as JoyMenu, MenuItem as JoyMenuItem, MenuButton, IconButton as JoyIconButton, Button as JoyButton } from "@mui/joy";
import { Bell, Menu, Plus, Search, ChevronDown } from "lucide-react";

import { Gate } from "../../shared";
import { PERMISSIONS } from "../../constants/permissions";
import { UserQuickNavigation } from "../../components";
import { Link } from "react-router-dom";

interface HeaderProps {
  onToggleCollapse?: () => void;
  isCollapsed?: boolean;
}

export default function Header({ onToggleCollapse }: HeaderProps) {
  return (
    <header>
      <Box className="main-header">
        <IconButton
          variant="plain"
          color="neutral"
          onClick={onToggleCollapse}
          sx={{
            display: { xs: "flex", sm: "none" },
            ml: -0.5,
            borderRadius: "sm",
          }}
        >
          <Menu size={20} />
        </IconButton>

        <Box
          sx={{ flex: 1, display: "flex", alignItems: "center", minWidth: 0 }}
        >
          <Input
            startDecorator={<Search size={16} />}
            variant="plain"
            sx={{
              display: { xs: "none", sm: "flex" },
              width: "100%",
              maxWidth: 420,
              "--Input-focusedThickness": "0px",
              borderRadius: 0,
              borderBottom: "1px solid transparent",
              "&:focus-within": {
                borderBottomColor: "divider",
              },
            }}
            placeholder="Search projects, tasks…"
          />
          <IconButton
            sx={{ display: { xs: "flex", sm: "none" }, borderRadius: "sm" }}
            variant="plain"
            color="neutral"
          >
            <Search size={20} />
          </IconButton>
        </Box>

        <Box className="main-header-action-items">
          <Gate anyOf={[PERMISSIONS.PROJECT_CREATE]}>
              <ButtonGroup
                variant="solid"
                color="primary"
                size="sm"
                sx={{ 
                  display: { xs: "none", md: "flex" },
                  '--ButtonGroup-radius': '4px' 
                }}
                aria-label="new project button group"
              >
                <JoyButton
                  startDecorator={<Plus size={16} />}
                  component={Link}
                  to="/project/new-quick"
                >
                  New Project
                </JoyButton>
                <Dropdown>
                  <MenuButton
                    slots={{ root: JoyIconButton }}
                    slotProps={{
                      root: {
                        color: "primary",
                        variant: "solid",
                        "aria-label": "Choose project creation type",
                      },
                    }}
                  >
                    <ChevronDown size={16} />
                  </MenuButton>
                  <JoyMenu
                    placement="bottom-end"
                    size="sm"
                    sx={{ borderRadius: "4px", minWidth: 200 }}
                  >
                    <JoyMenuItem component={Link} to="/project/new-quick">
                      Quick project
                    </JoyMenuItem>
                    <JoyMenuItem component={Link} to="/project/new">
                      Normal project
                    </JoyMenuItem>
                  </JoyMenu>
                </Dropdown>
              </ButtonGroup>
          </Gate>

          <IconButton
            variant="plain"
            color="neutral"
            sx={{ borderRadius: "sm" }}
          >
            <Bell size={18} />
          </IconButton>
          <UserQuickNavigation />
        </Box>
      </Box>
    </header>
  );
}
